import { RouteObject } from "react-router-dom";
import { ReplacementTransportOptionsList } from "../pages/admin/replacement-transports/options/ReplacementTransportOptionsList";
import { ReplacementTransportOptionCreate } from "../pages/admin/replacement-transports/options/ReplacementTransportOptionCreate";
import { ReplacementTransportOptionDetail } from "../pages/admin/replacement-transports/options/ReplacementTransportOptionDetail";
import { ReplacementTransportOptionEdit } from "../pages/admin/replacement-transports/options/ReplacementTransportOptionEdit";
import { ReplacementTransportPlansList } from "../pages/admin/replacement-transports/plans/ReplacementTransportPlanList";
import { ReplacementTransportPlanEdit } from "../pages/admin/replacement-transports/plans/ReplacementTransportPlanEdit";
import { ReplacementTransportPlanCreate } from "../pages/admin/replacement-transports/plans/ReplacementTransportPlanCreate";
import { ReplacementTransportPlanDetail } from "../pages/admin/replacement-transports/plans/ReplacementTransportPlanDetail";

export const replacementTransportRoutes: RouteObject[] = [
  {
    id: "replacement-transport-options-list",
    path: "options",
    element: <ReplacementTransportOptionsList />,
  },
  {
    id: "replacement-transport-option-create",
    path: "options/create",
    element: <ReplacementTransportOptionCreate />,
  },
  {
    id: "replacement-transport-option-detail",
    path: "options/:id",
    element: <ReplacementTransportOptionDetail />,
  },
  {
    id: "replacement-transport-option-edit",
    path: "options/:id/edit",
    element: <ReplacementTransportOptionEdit />,
  },
  {
    id: "replacement-transport-plans-list",
    path: "plans",
    element: <ReplacementTransportPlansList />,
  },
  {
    id: "replacement-transport-plan-create",
    path: "plans/create",
    element: <ReplacementTransportPlanCreate />,
  },
  {
    id: "replacement-transport-plan-detail",
    path: "plans/:id",
    element: <ReplacementTransportPlanDetail />,
  },
  {
    id: "replacement-transport-plan-edit",
    path: "plans/:id/edit",
    element: <ReplacementTransportPlanEdit />,
  },
];
